import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import adrActions from "../../_actions/adrActions";
import AlertModal from "../_common/AlertModal";

export default function AdrTentativeAgreementSelectionModalV3(props) {
  const { createTa, showTaSelectionModal, toggleTaSelectionModal, projectId, tabId } =
    props;

  const dispatch = useDispatch();

  const projLaborList = useSelector(
    (state) => state.labors.projLaborLists[projectId] || null
  );
  const projEquipList = useSelector(
    (state) => state.equipment.projEquipLists[projectId] || null
  );
  const projContractorList = useSelector(
    (state) => state.contractors.projContractorLists[projectId] || null
  );
  const wpc = useSelector((state) =>
    state.adr.openAdrs[tabId]
      ? state.adr.openAdrs[tabId].workPerformedClient || null
      : null
  );
  const laborSetClient = useSelector((state) =>
    state.adr.openAdrs[tabId] ? state.adr.openAdrs[tabId].laborSetClient || null : null
  );
  const equipmentSetClient = useSelector((state) =>
    state.adr.openAdrs[tabId]
      ? state.adr.openAdrs[tabId].equipmentSetClient || null
      : null
  );

  const [selectedWp, selectWp] = useState(null); // Value is wpTabId

  // For single contractor option:
  const [selectedContractor, selectContractor] = useState(null);

  const [showAlert_taExists, setShowAlert_taExists] = useState(false);
  const toggleAlert_taExists = () => setShowAlert_taExists(!showAlert_taExists);

  const contractorSet = useMemo(() => {
    const laborContractorSet = new Set();
    const equipContractorSet = new Set();

    Object.values(laborSetClient)
      .filter((lsr) => lsr.laborId && lsr.tradeId)
      .map((lsr) => {
        const labor = (projLaborList || []).find((l) => l.laborId === lsr.laborId);
        return labor ? labor.contractorId : 0;
      })
      .forEach((cId) => cId && laborContractorSet.add(cId));

    Object.values(equipmentSetClient)
      .filter((esr) => esr.equipmentId)
      .map((esr) => {
        const equip = (projEquipList || []).find(
          (e) => e.equipmentId === esr.equipmentId
        );
        return equip ? equip.contractorId : 0;
      })
      .forEach((cId) => cId && equipContractorSet.add(cId));

    return Array.from(
      new Set([...(laborContractorSet || []), ...(equipContractorSet || [])])
    );
  }, [laborSetClient, equipmentSetClient]);

  const wpSortOrder = useMemo(
    () =>
      wpc && Object.keys(wpc).length > 0
        ? dispatch(adrActions.getWorkPerformedSortOrder(tabId))
        : null,
    [wpc]
  );

  // Select first item by default
  useEffect(() => {
    if (wpSortOrder && wpSortOrder.length) {
      selectWp(wpSortOrder[0].wpTabId);
    }
  }, [wpSortOrder]);

  // Select first item by default
  useEffect(() => {
    if (contractorSet && contractorSet.length) {
      selectContractor(contractorSet[0]);
    }
  }, [contractorSet]);

  const handleClick_ok = (e) => {
    e.preventDefault();
    if (!selectedWp || !selectedContractor) return;
    const isUnique = dispatch(
      adrActions.tentativeAgreementIsUnique(
        tabId,
        wpc[selectedWp].workPerformedId,
        selectedContractor
      )
    );
    if (isUnique) createTa(selectedWp, selectedContractor);
    else toggleAlert_taExists();
  };

  const closeBtn = (
    <button
      className="close"
      onClick={() => toggleTaSelectionModal(!showTaSelectionModal)}
    >
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <React.Fragment>
      <Modal
        isOpen={showTaSelectionModal}
        toggle={() => toggleTaSelectionModal(!showTaSelectionModal)}
        fade={false}
        size={"md"}
      >
        <ModalHeader
          toggle={() => toggleTaSelectionModal(!showTaSelectionModal)}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="file-signature" className="fa-fw mr-2" />
          New Tentative Agreement
        </ModalHeader>
        <ModalBody>
          <div className="card mb-2">
            <div className="card-body p-2">
              <span className="font-weight-bold">Item/CO:</span>
              {wpSortOrder &&
                wpSortOrder
                  .filter((wpSo) => !wpc[wpSo.wpTabId].isIdle)
                  .map((wpSo) => (
                    <div key={`wpForTaSelector_${wpSo.wpTabId}`} className="form-row">
                      <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                        <div className="radio">
                          <input
                            type="radio"
                            name={`wpForTa_${wpSo.wpTabId}`}
                            id={`wpForTa_${wpSo.wpTabId}`}
                            checked={selectedWp === wpSo.wpTabId}
                            onChange={() => selectWp(wpSo.wpTabId)}
                            className="custom-control-input"
                          />
                          <label
                            htmlFor={`wpForTa_${wpSo.wpTabId}`}
                            className="custom-control-label my-auto"
                          >
                            {wpc[wpSo.wpTabId].wpFullCaption}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
          <div className="card">
            <div className="card-body p-2">
              <span className="font-weight-bold">Contractor:</span>
              <div className="d-flex flex-column">
                {(contractorSet || []).length > 0
                  ? contractorSet.map((cId, index) => {
                      const contractor = (projContractorList || []).find(
                        (c) => c.contractorId === cId
                      );

                      return (
                        <div key={`contractorOptionKey_${index}`} className="form-row">
                          <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                            <div className="radio">
                              <input
                                type="radio"
                                name={`ctrId_${cId}`}
                                id={`ctrId_${cId}`}
                                checked={selectedContractor === cId}
                                onChange={() => selectContractor(cId)}
                                className="custom-control-input"
                              />
                              <label
                                htmlFor={`ctrId_${cId}`}
                                className="custom-control-label my-auto"
                              >
                                {contractor ? contractor.name : "(Name N/A)"}
                              </label>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : "No contractor selected for this daily report."}
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group">
            <button
              name="addTa"
              id="addTa"
              className="btn btn-primary mr-2"
              onClick={handleClick_ok}
              disabled={!selectedWp || !selectedContractor}
            >
              OK
            </button>
            <button
              name="cancelTaSelection"
              id="cancelTaSelection"
              className="btn btn-secondary"
              onClick={() => toggleTaSelectionModal(!showTaSelectionModal)}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
      <AlertModal
        alertKey={"taExists"}
        alertTitle={"TA Already Exists"}
        alertTitleClass="bg-warning"
        alertTitleIcon="exclamation-triangle"
        alertText="A TA with same Item/CO and contractor already exists."
        acceptCaption={"OK"}
        acceptClass={"secondary"}
        provideReject={false}
        handleAlertAction={toggleAlert_taExists}
        showAlertModal={showAlert_taExists}
        toggleAlertModal={toggleAlert_taExists}
      />
    </React.Fragment>
  );
}
